import React from "react";
import Auth from "@aws-amplify/auth";
import styles from "../styles/SocialLogin.module.scss";
import { Link } from "react-router-dom";
import routes from "../constants/routes.json";
import classnames from "classnames";

//Social buttons on sign in/ signup pages
//Docs on Amplify Social Sign in/ Sign up: https://docs.amplify.aws/lib/auth/advanced/q/platform/js/#identity-pool-federation

//Social buttons on sign in/ signup pages
//Docs on Amplify Social Sign in/ Sign up: https://docs.amplify.aws/lib/auth/advanced/q/platform/js/#identity-pool-federation

export default function SocialLogin({
  isBuildboxClient,
  appleSignInAvailable,
  largeButtons = false,
}) {
  const FacebookIcon = "https://frontend-assets.buildbox.com/Icon_FB_white.svg";
  const GoogleIcon =
    "https://frontend-assets.buildbox.com/Icon_Google_white.svg";
  const AppleIcon = "https://frontend-assets.buildbox.com/Apple_logo_white.svg";

  async function googleLogin() {
    await storeForReferralProgram();
    await Auth.federatedSignIn({ provider: "Google" });
  }

  async function facebookLogin() {
    await storeForReferralProgram();
    await Auth.federatedSignIn({ provider: "Facebook" });
  }

  // https://aws.amazon.com/blogs/mobile/enable-sign-in-with-apple-on-your-app-with-aws-amplify/
  async function appleLogin() {
    await storeForReferralProgram();
    await Auth.federatedSignIn({ provider: "SignInWithApple" });
  }

  async function storeForReferralProgram() {
    if (largeButtons) {
      await sessionStorage.setItem("socialSignReferral", "true");
    }
  }

  const routeButtons = (children) => {
    if (isBuildboxClient) {
      return (
        <>
          <Link
            to={routes.CLIENT_AWAITING_GOOGLE_LOGIN}
            className={styles.buttonLink}
          >
            <button
              className={classnames(
                styles.socialIconClientBtn,
                styles.googleSocialLoginBtn
              )}
            >
              <img
                className={styles.socialIcon}
                src={GoogleIcon}
                alt="Google Logo"
              />
              <span>Google</span>
            </button>
          </Link>
          <Link
            to={routes.CLIENT_AWAITING_FACEBOOK_LOGIN}
            style={{ textDecoration: "none" }}
          >
            <button className={styles.socialIconClientBtn}>
              <img
                className={styles.socialIcon}
                src={FacebookIcon}
                alt="Facebook Logo"
              />
              <span>Facebook</span>
            </button>
          </Link>
          {appleSignInAvailable && (
            <Link
              to={routes.CLIENT_AWAITING_APPLE_LOGIN}
              style={{ textDecoration: "none" }}
            >
              <button className={styles.socialIconClientBtn}>
                <img
                  className={styles.socialIcon}
                  src={AppleIcon}
                  alt="Apple Logo"
                />
                <span>Apple</span>
              </button>
            </Link>
          )}
        </>
      );
    } else {
      return (
        <>
          <button
            className={classnames(
              styles.socialIconClientBtn,
              styles.googleSocialLoginBtn
            )}
            onClick={googleLogin}
          >
            <img
              className={styles.socialIcon}
              src={GoogleIcon}
              alt="Google Logo"
            />
            <span>Google</span>
          </button>
          <button
            className={styles.socialIconClientBtn}
            onClick={facebookLogin}
          >
            <img
              className={styles.socialIcon}
              src={FacebookIcon}
              alt="Facebook Logo"
            />
            <span>Facebook</span>
          </button>
          {appleSignInAvailable && (
            <button className={styles.socialIconClientBtn} onClick={appleLogin}>
              <img
                className={styles.socialIcon}
                src={AppleIcon}
                alt="Apple Logo"
              />
              <span>Apple</span>
            </button>
          )}
        </>
      );
    }
  };

  return (
    <div
      className={
        largeButtons ? styles.socialLoginReferral : styles.SocialLoginClient
      }
    >
      <div className={styles.separator}>
        <img
          className={styles.verticalLine}
          src={"https://dev-frontend-assets.s3.amazonaws.com/Line-1.svg"}
          alt="Or"
        />
        <span>or login with</span>
        <img
          className={styles.verticalLine}
          src={"https://dev-frontend-assets.s3.amazonaws.com/Line.svg"}
          alt="Or"
        />
      </div>
      <div className={styles.socialBtnsWrapper}>{routeButtons()}</div>
    </div>
  );
}
